'use client'

import { useState, useEffect } from 'react'
import { ProductFullSearchData } from '@/types/product.type'

interface LazyProductGridMobileProps {
  products: ProductFullSearchData[]
  ProductCardMobile: React.ComponentType<{ product: ProductFullSearchData }>
}

export default function LazyProductGridMobile({ products, ProductCardMobile }: LazyProductGridMobileProps) {
  const [mounted, setMounted] = useState(false)
  const [visibleProducts, setVisibleProducts] = useState<ProductFullSearchData[]>([])

  useEffect(() => {
    setMounted(true)
    setVisibleProducts(products)
  }, [products])

  if (!mounted) {
    return null // Avoid hydration mismatch
  }

  return (
    <div className="grid gap-2 lg:hidden p-2">
      {visibleProducts
        .map((product, index) => {
          if (!product || !product.id) return null
          return <ProductCardMobile key={`client-mobile-${product.id}-${index}`} product={product} />
        })
        .filter(Boolean)}

      {/* Loading indicator for remaining products */}
      {visibleProducts.length < products.length && (
        <div className="flex justify-center p-4">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0s]"></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.1s]"></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.2s]"></div>
          </div>
        </div>
      )}
    </div>
  )
}
